export default function SwapChangeNetworkAlert({ formData }) {
  return (
    <div className="transfers__notification transfers__notification_attention">
      <a className="link" href="/#">
        Сonnect your wallet to the {formData.routeFrom.name} network
      </a>
    </div>
  );
}
